import { ChatControllerContext } from './ChatControllerContextValue'

export function ChatControllerProvider({ value, children }) {
  return <ChatControllerContext.Provider value={value}>{children}</ChatControllerContext.Provider>
}
